"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var DomUtil_1 = require("../../utils/DomUtil");
var FindIndex_1 = require("../../utils/FindIndex");
var ReactHelpers_1 = require("../../utils/ReactHelpers");
var ListItemUtils_1 = require("../List/ListItemUtils");
var DropdownButton_1 = require("./DropdownButton");
exports.DropdownButtonType = DropdownButton_1.DropdownButtonType;
/**
 * A dropdown button which renders a popup React element satisfying `ListProps`,
 * and provides default accessibility attributes and keyboard behaviors.
 */
// tslint:disable-next-line:max-line-length
var SingleSelectDropdown = /** @class */ (function (_super) {
    tslib_1.__extends(SingleSelectDropdown, _super);
    function SingleSelectDropdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.defaultListId = DomUtil_1.generateId();
        _this.listId = function () { return _this.props.list.props.id || _this.defaultListId; };
        _this.done = null;
        _this.typeAheadQuery = '';
        _this.typeAheadTimeoutHandle = 0;
        _this.handleOpen = function (doneFn, rect) {
            if (_this.props.onOpen) {
                _this.props.onOpen(doneFn, rect);
            }
            _this.done = doneFn;
        };
        _this.handleClose = function () {
            _this.done = null;
            if (_this.props.onClose) {
                _this.props.onClose();
            }
        };
        _this.keyDownHandlers = Object.freeze({
            'Home': function (items) { return ListItemUtils_1.findSelectableItemIndex(items, -1, +1); },
            'End': function (items) { return ListItemUtils_1.findSelectableItemIndex(items, items.length, -1); },
            'ArrowUp': function (items) { return ListItemUtils_1.findSelectableItemIndex(items, ListItemUtils_1.findItemWithValue(items, _this.props.value), -1); },
            'ArrowDown': function (items) { return ListItemUtils_1.findSelectableItemIndex(items, ListItemUtils_1.findItemWithValue(items, _this.props.value), +1); },
        });
        _this.handleKeyDown = ReactHelpers_1.mergeEventHandlers(function (e) {
            if (_this.props.disabled || !_this.keyDownHandlers[e.key]) {
                return;
            }
            var items = _this.props.list.props.items;
            var newSelectedItemIndex = _this.keyDownHandlers[e.key](items);
            e.preventDefault();
            e.stopPropagation();
            var newValue = items[newSelectedItemIndex].value;
            if (newValue !== _this.props.value) {
                _this.handleSelect(newValue);
            }
        }, function (e) { return ReactHelpers_1.safeInvoke(_this.props.onKeyDown, e); });
        _this.handleKeyPress = ReactHelpers_1.mergeEventHandlers(function (e) {
            if (_this.props.disabled || e.key === ' ' || e.key === 'Enter' || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) {
                return;
            }
            window.clearTimeout(_this.typeAheadTimeoutHandle);
            _this.typeAheadTimeoutHandle = window.setTimeout(function () { return _this.typeAheadQuery = ''; }, 500);
            _this.typeAheadQuery += e.key;
            var items = _this.props.list.props.items;
            var currentIndex = FindIndex_1.findIndex(items, function (item) { return item.value === _this.props.value; });
            function lookFor(query) {
                // single-character queries start after the current item, but multiple-character queries start on the current item
                var startAt = currentIndex + (query.length > 1 ? 0 : 1);
                return FindIndex_1.findIndex(items, function (item) { return ListItemUtils_1.isSelectableItem(item) && item.value.toLowerCase().indexOf(query.toLowerCase()) === 0; }, startAt);
            }
            var nextIndex = lookFor(_this.typeAheadQuery);
            if (nextIndex < 0) {
                nextIndex = lookFor(e.key);
            }
            if (nextIndex >= 0 && currentIndex !== nextIndex) {
                _this.handleSelect(items[nextIndex].value);
                e.preventDefault();
                e.stopPropagation();
            }
        }, function (e) { return ReactHelpers_1.safeInvoke(_this.props.onKeyPress, e); });
        _this.handleSelect = function (value) {
            if (_this.props.onChange) {
                _this.props.onChange(value);
            }
            if (_this.done && !_this.props.onOpen) {
                _this.done();
            }
        };
        _this.renderPopupContent = function () {
            var list = _this.props.list;
            return React.cloneElement(list, {
                id: _this.listId(),
                onSelect: _this.handleSelect,
                selectOnEnterKey: true,
            });
        };
        return _this;
    }
    SingleSelectDropdown.prototype.shouldComponentUpdate = function (nextProps) {
        if (nextProps.list !== this.props.list) {
            // TFS 998221: list prop is not used directly in the render() method,
            // instead rebind this function so React knows to re-render the popupContent
            this.renderPopupContent = this.renderPopupContent.bind(this);
        }
        return true;
    };
    SingleSelectDropdown.prototype.render = function () {
        var _a = this.props, children = _a.children, list = _a.list, onChange = _a.onChange, renderPopupContent = _a.renderPopupContent, value = _a.value, dropdownProps = tslib_1.__rest(_a, ["children", "list", "onChange", "renderPopupContent", "value"]);
        return (React.createElement(DropdownButton_1.DropdownButton, tslib_1.__assign({ "aria-controls": this.listId() }, dropdownProps, { "aria-haspopup": 'listbox', focusOnClose: true, onClose: this.handleClose, onKeyDown: this.handleKeyDown, onKeyPress: this.handleKeyPress, onOpen: this.handleOpen, renderPopupContent: renderPopupContent || this.renderPopupContent }), children || value || ''));
    };
    return SingleSelectDropdown;
}(React.Component));
exports.SingleSelectDropdown = SingleSelectDropdown;
//# sourceMappingURL=SingleSelectDropdown.js.map